import { render, staticRenderFns } from "./ForgotPasswordEmail.vue?vue&type=template&id=2714feea&scoped=true&"
import script from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordEmail.vue?vue&type=style&index=0&id=2714feea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714feea",
  null
  
)

export default component.exports